const DISPLAY_MESSAGE = 'DISPLAY_MESSAGE';
const HIDE_MESSAGE = 'HIDE_MESSAGE';

export {
    DISPLAY_MESSAGE,
    HIDE_MESSAGE
}
